import { css } from 'lit';

// language=CSS
export const checkbox =
    css`
        a {
            display: block;
            position: relative;
            width: 100%;
            height: 45px;
            box-sizing: border-box;
            box-shadow: var(--sp-default-box-shadow);
            background-color: #fff;
            font-size: 14px;
            line-height: 45px;
            padding: 0 10px;
            border-radius: 3px;
            cursor: pointer;
            color: #000;
        }
        
        a.minimal {
            background-color: unset;
            box-shadow: none;
            font-size: var(--sp-font-size-smaller);
            height: 20px;
            line-height: 20px;
        }

        span {
            float: left;
            width: 15px;
            height: 15px;
            border: 5px solid rgb(var(--sp-greylight));
            border-radius: 3px;
            margin: 10px 10px 10px 0;
            background-color: rgb(var(--sp-greylight));
        }
        
        a.minimal span {
            background-color: #fff;
            border: 5px solid #fff;
            margin: 0 10px 0 0;
            width: 10px;
            height: 10px;
        }
        
        .disabled {
            color: #aaa
        }

        .checked span {
            background-color: rgb(var(--sp-color-b)) !important;
        }
        
        .checked .disabled span {
            background-color: rgb(var(--sp-color-d)) !important;
        }
    `;
